import { render, staticRenderFns } from "./FlashNewsGeneralView.vue?vue&type=template&id=109c6c68&"
import script from "./FlashNewsGeneralView.vue?vue&type=script&lang=ts&"
export * from "./FlashNewsGeneralView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('109c6c68')) {
      api.createRecord('109c6c68', component.options)
    } else {
      api.reload('109c6c68', component.options)
    }
    module.hot.accept("./FlashNewsGeneralView.vue?vue&type=template&id=109c6c68&", function () {
      api.rerender('109c6c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/flashNews/FlashNewsGeneralView.vue"
export default component.exports